import React from 'react';
import { ContextualMenu, FocusZoneTabbableElements, IContextualMenuItem, IContextualMenuProps } from '@fluentui/react';
import { useScreen } from 'common/hooks/useScreen';
import { merge } from 'lodash';

import { Drawer } from './Drawer';
import { getContextualMenuDrawerStyles } from './Drawer.styles';

export const ContextualMenuDrawer = (props: IContextualMenuProps) => {
  const { isMobileScreen } = useScreen();
  const { onDismiss, items } = props;
  const classNames = getContextualMenuDrawerStyles();

  if (!isMobileScreen) {
    return <ContextualMenu {...props} />;
  }
  return (
    <Drawer
      onDismiss={() => {
        if (onDismiss) {
          onDismiss(undefined, true);
        }
      }}
      styles={{
        body: {
          padding: '0px 0px 16px 0px',
        },
      }}
    >
      <ContextualMenu
        {...props}
        doNotLayer
        shouldFocusOnContainer={false}
        shouldFocusOnMount={true} // required for accessibility
        focusZoneProps={{ handleTabKey: FocusZoneTabbableElements.none, shouldFocusOnMount: false, allowFocusRoot: false }}
        calloutProps={{
          styles: {
            root: classNames.calloutRoot,
          },
        }}
        items={items.map((item) =>
          merge<IContextualMenuItem, Partial<IContextualMenuItem>>(item, { itemProps: { styles: { root: classNames.item } } })
        )}
        isBeakVisible={false}
      />
    </Drawer>
  );
};
